<template>
  <v-row>
    <v-col cols="12" md="10">
      <v-row>
        <v-col cols="12" md="4">
          <autocomplete-major
            v-model="major"
            item-text="title"
            item-value="id"
            placeholder="Chọn chuyên ngành"
            flat
            filled
            dense
            return-object
            required
            clearable
            :hide-details="$vuetify.breakpoint.smAndDown"
            class="mx-4"
            :class="{ 'mt-10': $vuetify.breakpoint.smAndDown }"
          ></autocomplete-major>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Tìm kiếm"
            single-line
            clearable
            hide-details
            dense
            filled
            class="mx-4"
            :class="{ 'mt-10': $vuetify.breakpoint.smAndDown }"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="2">
      <v-row>
        <v-col cols="12">
          <v-btn
            color="amber darken-1"
            class="white--text mx-4"
            :class="{ 'mt-10': $vuetify.breakpoint.smAndDown }"
            height="40"
            @click="onFilterChanged"
            depressed
          >
            <v-icon left dark>mdi-filter-outline</v-icon>Lọc
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'
import AutocompleteMajor from '@/components/basic/input/AutocompleteMajor'

export default {
  components: { AutocompleteMajor },
  props: {
    defaultFilters: Object,
  },
  data: () => ({
    major: '',
    position: '',
    search: '',
  }),
  computed: {
    ...mapState('constant', ['showcasePositions']),
    allShowcasePositions() {
      return [
        {
          title: 'Tất Cả',
          status: '',
        },
        ...this.showcasePositions,
      ]
    },
  },
  created() {
    this.reset()
  },
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        major: get(this.major, 'id', ''),
        search: this.search,
      })
    },
    reset() {
      this.major = ''
      this.position = ''
      this.search = ''
    },
  },
}
</script>
<style scoped>
.v-input--selection-controls,
.v-input__slot {
  margin: 0;
  padding: 0;
}
</style>
